<button
  *ngIf="isServer || isMobile; else plainHeader"
  class="m-0 mb-md-2 mt-md-n1 d-flex align-items-center justify-content-between column-header"
  shrdUicButton
  variant="tertiaryMinorBorderless"
  (click)="triggerToggle()"
>
  <span class="text-bold text-start pe-2">{{ sectionTitle }}</span>
  <shrd-uic-svg-icon
    class="d-md-none"
    [icon]="accordion?.isOpen ? iconName.ARROW_UP : iconName.ARROW_DOWN"
  ></shrd-uic-svg-icon>
</button>

<ng-template #plainHeader>
  <p class="text-bold">{{ sectionTitle }}</p>
</ng-template>

<shrd-uic-accordion *ngIf="!isServer && isMobile; else plainLst">
  <ng-container *ngTemplateOutlet="linkList"></ng-container>
</shrd-uic-accordion>

<ng-template #plainLst>
  <div class="d-none d-md-block">
    <ng-container *ngTemplateOutlet="linkList"></ng-container>
  </div>
</ng-template>

<hr *ngIf="!isLast && (isServer || isMobile)" class="d-md-none mx-n2" shrdUicHr [lineHeight]="1" />

<ng-template #linkList>
  <a
    *ngFor="let link of links; trackBy: trackByIndex"
    class="mt-0 mb-1 default-icon-color"
    shrdUicButton
    variant="navList"
    [href]="link.url"
    shrdUtcAutoTarget
  >
    <shrd-uic-svg-icon *ngIf="link.type" [icon]="link.type" [size]="sizeOption.SMALL"></shrd-uic-svg-icon>
    <span class="no-truncate">{{ link.title }}</span>
  </a>
</ng-template>
